import http from "../http-common";

class CmsService {
    getPage(pageKey) {
        return http.get(`cms/page/${pageKey}`);
    }
    updatePage(pageKey, data) {
        return http.put(`cms/page/${pageKey}`, data);
    }
    getAllPages() {
        return http.get('cms/pages');
    }
}

export default new CmsService();